import { WalletConnectContext } from './useWalletConnect';
import { useTransactionBuilderStore } from '../useTransactionBuilderStore';
import { type ReactElement, type ReactNode } from 'react';
import { useWalletConnectController } from './useWalletConnectController';
import { UseWalletConnectResult } from './types';

/**
 * The Outer Provider wrapper component that goes around our /new-transaction page
 *
 * This allows any child component to have access to all fields on `UseWalletConnectResult`
 * through the use of the hook `useWalletConnect`
 */
export function TransactionBuilderWalletConnectProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const account = useTransactionBuilderStore((state) => state.account);
  const network = useTransactionBuilderStore((state) => state.network);
  const walletConnectValue: UseWalletConnectResult = useWalletConnectController(
    account?.address,
    network
  );

  return (
    <WalletConnectContext.Provider value={walletConnectValue}>
      {children}
    </WalletConnectContext.Provider>
  );
}
